import React from "react";
import PageContainer from "../components/PageContainer";
import ManageTeam from "./ManageTeam";

const TeamManagement: React.FC = () => {
  return (
    <PageContainer sx={{ mt: 2 }}>
      <ManageTeam hideHeader={false} />
    </PageContainer>
  );
};

export default TeamManagement;
